/* tslint:disable */

declare var Object: any;
export interface TtadondutydeclarationInterface {
  "requestNo": string;
  "ondutyReqno": string;
  "companyId": number;
  "requestedby"?: string;
  "requestfor"?: string;
  "requestdate"?: Date;
  "purposeCode": string;
  "totalDestination": number;
  "remark"?: string;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "uploadFilename"?: string;
  tcltrequests?: any;
  rel_purpose?: any;
  rel_personal?: any;
  ttadondutydeclarationdtls?: any[];
}

export class Ttadondutydeclaration implements TtadondutydeclarationInterface {
  "requestNo": string;
  "ondutyReqno": string;
  "companyId": number;
  "requestedby": string;
  "requestfor": string;
  "requestdate": Date;
  "purposeCode": string;
  "totalDestination": number;
  "remark": string;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "uploadFilename": string;
  tcltrequests: any;
  rel_purpose: any;
  rel_personal: any;
  ttadondutydeclarationdtls: any[];
  constructor(data?: TtadondutydeclarationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttadondutydeclaration`.
   */
  public static getModelName() {
    return "Ttadondutydeclaration";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttadondutydeclaration for dynamic purposes.
  **/
  public static factory(data: TtadondutydeclarationInterface): Ttadondutydeclaration{
    return new Ttadondutydeclaration(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttadondutydeclaration',
      plural: 'Ttadondutydeclarations',
      path: 'Ttadondutydeclarations',
      properties: {
        "requestNo": {
          name: 'requestNo',
          type: 'string'
        },
        "ondutyReqno": {
          name: 'ondutyReqno',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "requestedby": {
          name: 'requestedby',
          type: 'string'
        },
        "requestfor": {
          name: 'requestfor',
          type: 'string'
        },
        "requestdate": {
          name: 'requestdate',
          type: 'Date'
        },
        "purposeCode": {
          name: 'purposeCode',
          type: 'string'
        },
        "totalDestination": {
          name: 'totalDestination',
          type: 'number'
        },
        "remark": {
          name: 'remark',
          type: 'string'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "uploadFilename": {
          name: 'uploadFilename',
          type: 'string'
        },
      },
      relations: {
        tcltrequests: {
          name: 'tcltrequests',
          type: 'any',
          model: ''
        },
        rel_purpose: {
          name: 'rel_purpose',
          type: 'any',
          model: ''
        },
        rel_personal: {
          name: 'rel_personal',
          type: 'any',
          model: ''
        },
        ttadondutydeclarationdtls: {
          name: 'ttadondutydeclarationdtls',
          type: 'any[]',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttadondutydeclaration.ts